import { LayoutModule } from '@angular/cdk/layout';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbTimeAdapter, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoModule } from '@ngneat/transloco';
import { NgbTimeStringAdapter } from '../config/app.config';
import { ChiplistAutocompleteComponent } from './chiplist-ac/chiplist-ac.component';
import { DynamicTreeComponent } from './dynamic-tree/dynamic-tree.component';
import { FieldChiplistComponent } from './field-chiplist/field-chiplist.component';
import { DropFileDirective } from './file-uploader/dropfile.directive';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { LocaleTextComponent } from './localetext/localetext.component';
import { MultiDropFileDirective } from './multifile-uploader/multidropfile.directive';
import { MultiFileUploaderComponent } from './multifile-uploader/multifile-uploader.component';
import { BeautifyTaskSidebarComponent } from './task-sidebar/beautify-task-sidebar/beautify-task-sidebar.component';
import { TaskDetailsSidebarComponent } from './task-sidebar/task-details-sidebar/task-details-sidebar.component';
import { TimepickerAutofillComponent } from './timepicker-autofill/timepicker-autofill.component';
import { SharedModule } from '../../shared/shared.module';
import { FuseCardModule } from '../../../@fuse/components/card/card.module';

@NgModule({
    declarations: [
        ChiplistAutocompleteComponent,
        FieldChiplistComponent,
        FileUploaderComponent,
        LocaleTextComponent,
        DropFileDirective,
        MultiFileUploaderComponent,
        MultiDropFileDirective,
        DynamicTreeComponent,
        BeautifyTaskSidebarComponent,
        TaskDetailsSidebarComponent,
    ],
    imports: [
        RouterModule,
        SharedModule,
        TranslocoModule,
        LayoutModule,
        FuseCardModule,
        NgbTimepickerModule,
        TimepickerAutofillComponent,
    ],
    exports: [
        ChiplistAutocompleteComponent,
        FieldChiplistComponent,
        FileUploaderComponent,
        LocaleTextComponent,
        DropFileDirective,
        MultiFileUploaderComponent,
        MultiDropFileDirective,
        DynamicTreeComponent,
        TimepickerAutofillComponent,
        TaskDetailsSidebarComponent,
        BeautifyTaskSidebarComponent,
    ],
    providers: [
        { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }
    ]
})
export class ComponentsModule { }
